<template>
  <div id="index" :class="`main-${device}`">
    <section class="banner_wrapper">
      <div class="swipeBox">
        <swiper
          ref="swipe"
          :swiper="true"
          :swiperSlides="banner"
          :button="false"
          :pagination="true"
        >
          <template v-slot:bannerinfo="scope">
            <div class="container">
              <div class="bannerinfo">
                <div class="img_wrapper flex a_center" v-if="device == 'pc'">
                  <img class="gameimg" :src="scope.info.game_logo" alt="" />
                  <div class="gamecode">
                    <img
                      class="gamecodeimg"
                      :src="scope.info.game_qr_code"
                      alt=""
                    />
                    <span class="arrow"></span>
                    <span class="arrowborder"></span>
                  </div>
                </div>
                <div class="name">{{ scope.info.game_name }}</div>
                <div class="title">{{ scope.info.game_subtitle }}</div>
                <div v-if="device == 'pc'" class="desc two-line">
                  {{ scope.info.game_introduction }}
                </div>
                <el-button
                  round
                  type="primary"
                  @click="$router.push('/download?id=' + scope.info.game_id)"
                  >查看详情</el-button
                >
              </div>
            </div>
          </template>
        </swiper>
        <div class="news_wrapper container" v-if="device == 'pc'&&othergamelist.length">
          <div class="othergamelist">
            <ul>
              <li
                v-for="(item, index) in othergamelist"
                :key="index"
                :class="active == index ? 'active' : ''"
                @click="active = index"
              >
                <div class="img">
                  <img :src="item.logo" alt="" />
                </div>
                <div class="content">
                  <div class="gamename">{{ item.name }}</div>
                  <div class="gamedesc one-line">{{ item.introduction }}</div>
                </div>
              </li>
            </ul>
          </div>
          <div class="biggameimg">
            <img v-if="othergamelist[active]" :src="othergamelist[active].thumbnail" alt="" />
          </div>
          <div class="newslist">
            <div class="title two-line">
              {{ othergamelist[active]&&othergamelist[active].raider_title }}
            </div>
            <div class="light"></div>
            <div
              class="recommend_wrapper pointer"
              :style="{ width: width + 40 + 'px' }"
              v-if="othergamelist[active]&&othergamelist[active].recommend.title"
              @click="
                $router.push(
                  '/introduce?id=' + othergamelist[active].recommend.id
                )
              "
            >
              <span class="recommend">推荐</span>
              <span class="text one-line">{{
                othergamelist[active]&&othergamelist[active].recommend.title
              }}</span>
            </div>
            <div class="news">
              <ul>
                <li
                  v-for="(item, index) in othergamelist[active]&&othergamelist[active].raider_list"
                  :key="index"
                  @click="$router.push('/introduce?id=' + item.id)"
                  class="pointer"
                >
                  <img src="@@/images/pc/index_newtag.png" alt="" />
                  <span class="one-line" :style="{ width: width + 'px' }">{{
                    item.title
                  }}</span>
                  <span>{{ item.updated_at.split(' ')[0] }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="game_wrapper">
      <div class="container">
        <div class="content">
          <div class="header_wrapper a_center flex">
            <div class="title">
              热门游戏
            </div>
            <div class="more">
              <el-button type="default" @click="jump('/bingo', 2)"
                >更多</el-button
              >
            </div>
          </div>
          <div class="gamelist">
            <ul>
              <li
                v-for="(item, index) in gamelist"
                :key="index"
                @click="
                  device == 'pc' ? '' : $router.push('/download?id=' + item.id)
                "
              >
                <div class="img">
                  <img v-if="item.thumbnail" :src="item.thumbnail" alt="" />
                </div>
                <div class="text_wrapper">
                  <div class="tag" v-if="device == 'mobile'">热门游戏</div>
                  <div class="title one-line">{{ item.name }}</div>
                  <div
                    class="desc"
                    :class="device == 'pc' ? 'two-line' : 'one-line'"
                  >
                    {{ item.introduction }}
                  </div>
                  <div class="download">
                    <span @click="$router.push('/download?id=' + item.id)"
                      >前往下载</span
                    >
                    <img
                      @click="$router.push('/download?id=' + item.id)"
                      src="@@/images/pc/download.png"
                      alt=""
                    />
                  </div>
                </div>
                <img
                  v-if="device == 'mobile'"
                  class="arrow"
                  src="@@/images/mobile/index_arrow.png"
                  alt=""
                />
              </li>
            </ul>
          </div>
          <div
            class="more"
            v-if="device == 'mobile'"
            @click="jump('/bingo', 2)"
          >
            查看更多
          </div>
        </div>
      </div>
    </section>
    <section class="news_wrapper" v-if="device == 'mobile'">
      <div class="newslist">
        <div
          class="recommend_wrapper"
          @click="
            $router.push('/introduce?id=' + othergamelist[active].recommend.id)
          "
        >
          <span class="recommend">推荐</span>
          <span class="text one-line">{{
            othergamelist[active]&&othergamelist[active].recommend.title
          }}</span>
        </div>
        <div class="news">
          <ul :style="{ height: height }">
            <li
              v-for="(item, index) in mobileNewsList"
              :key="index"
              @click="$router.push('/introduce?id=' + item.id)"
              class="pointer"
            >
              <span class="one-line">{{ item.title }}</span>
              <span>{{ item.updated_at.split(' ')[0] }}</span>
            </li>
          </ul>
        </div>
        <div class="more" @click="height = 'auto'" v-if="height != 'auto'">
          查看更多
        </div>
      </div>
    </section>
    <section class="recruitment_wrapper">
      <div class="container">
        <div class="content">
          <div class="header_wrapper a_center flex">
            <div class="title">
              招聘信息
            </div>
            <div class="more">
              <el-button type="default" @click="jump('/recruitment', 4)"
                >更多</el-button
              >
            </div>
          </div>
          <div class="recruitment_info flex">
            <div class="left_wrapper" v-if="device == 'pc'">
              <ul>
                <li v-for="(item, index) in recruitmentcatalog" :key="index">
                  <div class="catalog">{{ item.name }}</div>
                  <div class="position_wrapper flex_wrapper">
                    <div
                      class="position"
                      :class="childitem.id == jobid ? 'acive' : ''"
                      @click="changeJob(childitem)"
                      v-for="(childitem, childindex) in item.list"
                      :key="childindex"
                    >
                      {{ childitem.name }}
                    </div>
                  </div>

                  <div
                    class="posnum pointer"
                    @click="(recruitmentactive = index), (jobid = '')"
                  >
                    共{{ item.total }}个职位 >>
                  </div>
                </li>
              </ul>
            </div>
            <div class="right_wrapper" v-if="device == 'pc'">
              <ul v-if="!jobid">
                <li
                  v-for="(item, index) in recruitmentcatalog[recruitmentactive]&&recruitmentcatalog[recruitmentactive]
                    .list"
                  :key="index"
                  class="pointer"
                  @click="jump('/recruitment?title=' + item.name, 4)"
                >
                  <div class="content_wrapper">
                    <div class="title pointer">
                      {{ item.name }}
                    </div>
                    <div class="base one-line">{{ item.address }}</div>
                    <div class="desc two-line" v-html="item.content"></div>
                  </div>
                  <img
                    v-if="device == 'mobile'"
                    class="arrow"
                    src="@@/images/mobile/index_arrow.png"
                    alt=""
                  />
                </li>
              </ul>
              <ul v-else>
                <li>
                  <div class="content_wrapper">
                    <div class="title">{{ jobdetails.name }}</div>
                    <div class="base one-line">{{ jobdetails.address }}</div>
                    <div class="desc" v-html="jobdetails.content"></div>
                    <div class="button j_a_center" style="margin-top:20px;">
                      <el-button
                        type="danger"
                        @click="$refs.contact.showtoggle = true"
                        >投递简历</el-button
                      >
                    </div>
                  </div>
                  <img
                    v-if="device == 'mobile'"
                    class="arrow"
                    src="@@/images/mobile/index_arrow.png"
                    alt=""
                  />
                </li>
              </ul>
            </div>
            <div class="right_wrapper" v-else>
             <ul>
                <li
                  v-for="(item, index) in recruitmentlist"
                  class="pointer"
                  :key="index"
                  @click="jump('/recruitment?title=' + item.name, 4)"
                >
                  <div class="content_wrapper">
                    <div class="title pointer">
                      {{ item.name }}
                    </div>
                    <div class="base one-line">{{ item.address }}</div>
                    <div class="desc two-line" v-html="item.content"></div>
                  </div>
                  <img
                    class="arrow"
                    src="@@/images/mobile/index_arrow.png"
                    alt=""
                  />
                </li>
              </ul>
              <div
                class="more"
                @click="jump('/recruitment', 4)"
              >
                查看更多
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <contact ref="contact"></contact>
  </div>
</template>

<script>
export default {
  inject: ["changeActive"],
  components: {
    //轮播图
    swiper: () => import("@/components/swiper.vue"),
    contact: () => import("@/components/contact.vue")
  },
  data() {
    return {
      active: 0,
      banner: [],
      othergamelist: [],
      gamelist: [],
      recruitmentcatalog: [],
      width: "2rem",
      recruitmentactive: 0,
      jobid: "",
      jobdetails: {},
      mobileNewsList: [],
      recruitmentlist:[],
      height: "300px"
    };
  },
  created() {
    let that = this;
    window.onresize = function() {
      let othergameListWidth = $(".othergamelist").width();
      let bigimageWidth = $(".biggameimg").width();
      that.width = 1120 - othergameListWidth - bigimageWidth;
    };

    window.addEventListener("onresize", function() {});
    this.getHome();
  },
  mounted() {
    setTimeout(() => {
      let othergameListWidth = $(".othergamelist").width();
      let bigimageWidth = $(".biggameimg").width();
      this.width = 1120 - othergameListWidth - bigimageWidth;
    }, 500);
  },
  methods: {
    jump(url, index) {
      this.$router.push(url).catch(err => {
        err;
      });
      // this.active=index;
      window.localStorage.setItem("active", index);
      this.changeActive(index);
    },
    // 获取首页信息
    getHome() {
      this.$api.getHome().then(res => {
        this.banner = res.data.banner_list;
        this.mobileNewsList = [];
        let raiderList = JSON.parse(JSON.stringify(res.data.raider_list));
        res.data.raider_list.forEach(item => {
          item.recommend = {};
          item.raider_list.forEach((childitem, childindex) => {
            if (childitem.is_recommend == 1) {
              item.recommend = childitem;
              item.raider_list.splice(childindex, 1);
            }
          });
        });
        raiderList.forEach(item => {
          item.raider_list.forEach(childitem => {
            this.mobileNewsList.push(childitem);
          });
        });
        let index = this.mobileNewsList.findIndex(
          item => item.is_recommend == 1
        );
        this.mobileNewsList.splice(index, 1);
        console.log(this.mobileNewsList, "this.mobileNewsList");
        this.othergamelist = res.data.raider_list.slice(0, 4);
        this.gamelist = res.data.hot_game_list;
        res.data.job_offers_list.forEach(item=>{
          if(item.list.length){
            this.recruitmentlist.push(item.list[0])
          }
        })
        this.recruitmentcatalog = res.data.job_offers_list;
      });
    },
    // 切换职位
    changeJob(item) {
      this.jobid = item.id;
      this.jobdetails = item;
    }
  },
  computed: {}
};
</script>

<style lang="less" scoped="scoped">
// pc端样式
.main-pc {
  overflow-x: hidden;
  .banner_wrapper{
    min-height: 600px;
  }
  .swipeBox {
    position: relative;
  }
  .bannerinfo {
    position: absolute;
    width: 2.4rem;
    height: auto;
    background: rgba(0, 0, 0, 0.4);
    bottom: 2.5rem;
    left: 0;
    padding: 0.14rem;
    overflow: hidden;
    .img_wrapper {
      margin-bottom: 0.1rem;
      img {
        width: 0.48rem;
        height: 0.48rem;
        border-radius: 0.04rem;
        overflow: hidden;
      }
      .gamecode {
        position: relative;
        border: 1px solid #e60012;
        border-radius: 0.04rem;
        z-index: 2;
        margin-left: 0.1rem;
        span.arrow {
          width: 0;
          height: 0;
          border: 0.04rem solid transparent;
          border-right-color: #fff;
          position: absolute;
          z-index: 3;
          transform: translateY(-50%);
          top: 50%;
          left: -0.08rem;
        }
        span.arrowborder {
          width: 0;
          height: 0;
          border: 0.05rem solid transparent;
          border-right-color: #e60012;
          position: absolute;
          z-index: 1;
          transform: translateY(-50%);
          top: 50%;
          left: -0.11rem;
        }
      }
    }
    .name {
      font-size: 0.16rem;
      color: #fff;
      font-weight: bold;
      margin-top: 0.1rem;
    }
    .title {
      font-size: 0.16rem;
      color: #fff;
      font-weight: bold;
      margin-bottom: 0.08rem;
    }
    .desc {
      color: #fff;
      font-size: 0.1rem;
      padding-top: 0.08rem;
      border-top: 1px solid #fff;
    }
    /deep/.el-button {
      padding: 0.05rem 0.1rem;
      margin-top: 0.1rem;
      font-size: 0.1rem;
      background-color: #098deb;
    }
  }

  .news_wrapper {
    position: absolute;
    bottom: 0;
    display: flex;
    z-index: 99;
    font-size: 0.1rem;
    color: #fff;
    background: #282b2d;
    height: 2.08rem;
    .othergamelist {
      height: 2.08rem;
      max-width: 230px;
      ul {
        li {
          display: flex;
          // width: 1.6rem;
          height: 0.52rem;
          align-items: center;
          padding: 0 0.1rem;
          position: relative;
          cursor: pointer;
          .img {
            margin-right: 0.1rem;
            img {
              width: 0.3rem;
              height: 0.3rem;
            }
          }
          .content {
            flex: 1;
            .gamename {
              font-size: 0.1rem;
              font-weight: bold;
            }
            .gamedesc {
              font-size: 0.06rem;
              transform: scale(0.8);
              transform-origin: left;
              max-width: 190px;
            }
          }
          &.active {
            background: #080909;
            &::after {
              content: " ";
              width: 0;
              height: 0;
              border: 0.07rem solid transparent;
              border-left-color: #080909;
              position: absolute;
              z-index: 3;
              transform: translateY(-50%);
              top: 50%;
              right: -0.14rem;
            }
          }
        }
      }
    }
    .biggameimg {
      height: 2.08rem;
      max-width: 454px;
      img {
        display: block;
        object-fit: cover;
        max-width: 454px;
        height: 2.08rem;
      }
    }
    .newslist {
      padding: 0.15rem;
      max-width: 516px;
      .title {
        color: #c82828;
        font-size: 0.16rem;
        font-weight: bold;
      }
      .light {
        height: 1px;
        background: #333638;
        margin: 0.05rem 0 0.1rem;
      }
      .recommend_wrapper {
        display: flex;
        align-items: center;
        margin-bottom: 0.1rem;
        background: #333638;
        .recommend {
          font-size: 0.1rem;
          flex: none;
          background: #c82828;
          padding: 0.01rem 0.04rem;
          border-radius: 0.01rem;
          position: relative;
          margin-right: 0.1rem;
          &::after {
            content: " ";
            width: 0;
            height: 0;
            border: 0.03rem solid transparent;
            border-left-color: #c82828;
            position: absolute;
            z-index: 3;
            transform: translateY(-50%);
            top: 50%;
            right: -0.06rem;
          }
        }
      }
      .news {
        ul {
          display: inline-block;
          li {
            display: flex;
            color: #7a8288;
            align-items: center;
            margin-bottom: 0.05rem;
            img {
              flex: none;
              width: 0.1rem;
              height: 0.1rem;
              margin-right: 0.06rem;
            }
            span:nth-child(2) {
              font-size: 0.1rem;
              flex: 1;
              width: 2rem;
              margin-right: 10px;
            }
          }
        }
      }
    }
  }

  .game_wrapper {
    .content {
      margin-top: 132px;
    }
    .header_wrapper {
      margin-bottom: 40px;

      .title {
        color: #828df4;
        font-size: 34px;
        font-weight: bold;
        background-image: url("~@@/images/pc/title_border.png");
        background-repeat: no-repeat;
        background-position: left bottom;
        padding-left: 28px;
        flex: 1;
      }
    }

    .gamelist {
      margin-bottom: 99px;
      ul {
        margin-right: -28px;
        flex-wrap: wrap;
        display: flex;
        li {
          margin-right: 36px;
          margin-bottom: 36px;
          width: 370px;
          height: 400px;
          border: 1px solid #ccc;
          position: relative;
          background: #fff;

          &::before {
            content: ".";
            background: #b5cadc;
            position: absolute;
            width: 368px;
            height: 398px;
            bottom: -15px;
            right: -15px;
            z-index: -1;
            transition: all 1s;
          }
          // &:hover {
          //   cursor: pointer;
          //   &::before {
          //     content: ".";
          //     background: #b5cadc;
          //     position: absolute;
          //     width: 368px;
          //     height: 398px;
          //     bottom: -15px;
          //     right: -15px;
          //     z-index: -1;
          //     transition: all 1s;
          //   }
          // }

          .text_wrapper {
            margin: 0 18px;
          }
          .img {
            width: 100%;
            height: 244px;
            overflow: hidden;
            display: block;
            img {
              object-fit: cover;
              width: 100%;
              height: 244px;
            }
          }
          .title {
            font-size: 20px;
            font-weight: bold;
            margin: 18px 0 10px;
            color: #52575a;
          }
          .desc {
            color: #52575a;
            font-size: 16px;
          }
          .download {
            position: absolute;
            bottom: 0;
            left: 18px;
            right: 18px;
            text-align: right;
            cursor: pointer;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            border-top: 1px solid #ccc;
            font-size: 16px;
            &:hover{
              color: #7180ff;
            }
            img {
              width: 18px;
              height: 18px;
              margin-left: 12px;
            }
          }
        }
      }
    }
  }
  .recruitment_wrapper {
    .content {
      margin-top: 132px;
    }
    .header_wrapper {
      margin-bottom: 20px;

      .title {
        color: #828df4;
        font-size: 34px;
        font-weight: bold;
        background-image: url("~@@/images/pc/title_border.png");
        background-repeat: no-repeat;
        background-position: left bottom;
        padding-left: 28px;
        flex: 1;
      }
    }
    .recruitment_info {
      color: #52575a;
      padding-bottom: 120px;
      .left_wrapper {
        width: 400px;
        padding-top: 20px;
        border-right: 1px solid #ccc;
        margin-left: 30px;
        ul {
          width: 420px;
          li {
            margin-bottom: 45px;
            .catalog {
              font-size: 25px;
              font-weight: bold;
            }
            .position_wrapper {
              display: flex;
              width: 380px;
              flex-wrap: wrap;
            }
            .position {
              font-size: 22px;
              display: inline-flex;
              margin-right: 10px;
              cursor: pointer;
              &:hover {
                color: #7180ff;
              }
              &.acive {
                color: #7180ff;
              }
            }
            .posnum {
              color: #7180ff;
              font-size: 22px;
            }
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
      .right_wrapper {
        padding-left: 80px;
        padding-top: 20px;

        ul {
          li {
            margin-bottom: 80px;
            .title {
              font-size: 25px;
              font-weight: bold;
            }
            .base {
              font-size: 22px;
            }
            .desc {
              font-size: 22px !important;
              /deep/span,
              /deep/p {
                font-size: 22px !important;
              }
            }
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
}
// 移动端
.main-mobile {
  overflow-x: hidden;
  .swipeBox {
    position: relative;
  }
  .bannerinfo {
    position: absolute;
    width: 6rem;
    // background: rgba(0, 0, 0, 0.4);
    bottom: 1.28rem;
    left: 0;
    right: 0;
    margin: 0 auto;
    overflow: hidden;
    text-align: center;
    .img_wrapper {
      img {
        width: 0.48rem;
        height: 0.48rem;
        border-radius: 0.04rem;
        overflow: hidden;
      }
      .gamecode {
        position: relative;
        border: 0.9975px solid #e60012;
        border-radius: 0.04rem;
        z-index: 2;
        margin-left: 0.1rem;
        span.arrow {
          width: 0;
          height: 0;
          border: 0.04rem solid transparent;
          border-right-color: #fff;
          position: absolute;
          z-index: 3;
          transform: translateY(-50%);
          top: 50%;
          left: -0.08rem;
        }
        span.arrowborder {
          width: 0;
          height: 0;
          border: 0.05rem solid transparent;
          border-right-color: #e60012;
          position: absolute;
          z-index: 1;
          transform: translateY(-50%);
          top: 50%;
          left: -0.11rem;
        }
      }
    }
    .name {
      font-size: 0.8267rem;
      color: #fff;
      font-weight: bold;
    }
    .title {
      font-size: 0.8267rem;
      color: #fff;
      font-weight: bold;
      margin-top: 0.1rem;
    }
    .desc {
      color: #fff;
      font-size: 0.1rem;
      padding-top: 0.08rem;
      border-top: 0.9975px solid #fff;
    }
    /deep/.el-button {
      padding: 0;
      width: 2.8667rem;
      height: 0.9467rem;
      margin-top: 0.6rem;
      font-size: 0.3333rem;
      background-color: #098deb;
    }
  }

  .news_wrapper {
    .newslist {
      padding: 0.2667rem;
      margin-top: 0.2667rem;
      .title {
        color: #c82828;
        font-size: 0.16rem;
        font-weight: bold;
      }
      .light {
        height: 0.9975px;
        background: #333638;
        margin: 0.05rem 0 0.1rem;
      }
      .recommend_wrapper {
        display: flex;
        align-items: center;
        width: 9.4533rem;
        height: 0.8267rem;
        background: #e9e9e9;
        margin: 0 auto 0.2533rem;
        padding-right: 0.1rem;
        .recommend {
          font-size: 0.4rem;
          flex: none;
          background: #c82828;
          padding: 0.01rem 0.04rem;
          border-radius: 0.01rem;
          position: relative;
          margin-right: 0.2667rem;
          width: 1.5733rem;
          height: 0.8267rem;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          &::after {
            content: " ";
            width: 0;
            height: 0;
            border: 0.1rem solid transparent;
            border-left-color: #c82828;
            position: absolute;
            z-index: 3;
            transform: translateY(-50%);
            top: 50%;
            right: -0.2rem;
          }
        }
        .text {
          font-size: 0.4rem;
        }
      }
      .news {
        ul {
          display: inline-block;
          overflow: hidden;

          li {
            display: flex;
            color: #7a8288;
            align-items: center;
            margin-bottom: 0.05rem;
            border-bottom: 0.0267rem solid #d0d0d0;
            padding: 0.5333rem 0;
            width: 9.4533rem;
            &:first-child {
              border-top: 0.0267rem solid #d0d0d0;
            }
            img {
              flex: none;
              width: 0.1rem;
              height: 0.1rem;
              margin-right: 0.06rem;
              display: none;
            }
            span:first-child {
              font-size: 0.3333rem;
              flex: 1;
              color: #2a2a2a;
              margin-right: 0.4rem;
            }
            span:nth-child(2) {
              font-size: 0.3333rem;
              color: #a8a8a9;
            }
          }
        }
      }
      .more {
        width: 9.4533rem;
        height: 0.8933rem;
        background: #e9e9e9;
        font-size: 0.2667rem;
        margin: 0.24rem auto 0.04rem;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #919191;
      }
    }
  }

  .game_wrapper {
    border-bottom: 0.1467rem solid #e9e9e9;
    .content {
      margin-top: 1.0267rem;
    }
    .header_wrapper {
      margin-bottom: 0.5333rem;

      .title {
        color: #828df4;
        font-size: 0.4533rem;
        font-weight: bold;
        text-align: center;
        background-image: url("~@@/images/pc/title_border.png");
        background-repeat: no-repeat;
        background-position: center bottom;
        background-size: 2.6rem 0.1467rem;
        flex: 1;
      }
      .more {
        display: none;
      }
    }
    .gamelist {
      // margin-bottom: 1.32rem;
      ul {
        flex-wrap: wrap;
        display: flex;
        li {
          border-bottom: 0.0133rem solid #ccc;
          position: relative;
          background: #fff;
          margin: 0 0.2667rem;
          display: flex;
          padding: 0.36rem 0;
          align-items: center;
          &:first-child {
            border-top: 0.0133rem solid #ccc;
          }
          .text_wrapper {
            height: 1.9067rem;
            margin: 0 0.4rem;
            width: 6.6rem;
            .tag {
              width: 1.8533rem;
              height: 0.48rem;
              background: #fd8429;
              border-radius: 0.08rem;
              color: #fff;
              display: flex;
              align-items: center;
              font-size: 0.2933rem;
              justify-content: center;
            }
          }
          .img {
            width: 1.9067rem;
            height: 1.9067rem;
            overflow: hidden;
            display: block;
            border-radius: 0.1rem;
            flex: none;
            img {
              object-fit: cover;
              width: 1.9067rem;
              height: 1.9067rem;
            }
          }
          .title {
            font-size: 0.4rem;
            font-weight: bold;
            margin: 0.2533rem 0 0.1rem;
            color: #52575a;
          }
          .desc {
            color: #a2a2a3;
            font-size: 0.2933rem;
          }
          .arrow {
            width: 0.12rem;
            height: 0.2933rem;
          }
          .download {
            position: absolute;
            bottom: 0;
            left: 0.24rem;
            right: 0.24rem;
            text-align: right;
            cursor: pointer;
            height: 0.5333rem;
            display: none;
            align-items: center;
            justify-content: flex-end;
            // border-top: 0.0133rem solid #ccc;
            font-size: 0.2133rem;
            img {
              width: 0.24rem;
              height: 0.24rem;
              margin-left: 0.16rem;
            }
          }
        }
      }
    }
    .more {
      width: 9.4533rem;
      height: 0.8933rem;
      background: #e9e9e9;
      font-size: 0.2667rem;
      margin: 0.24rem auto;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #919191;
    }
  }
  .recruitment_wrapper {
    background: #e9e9e9;
    .content {
      padding-top: 0.76rem;
    }
    .header_wrapper {
      margin-bottom: 0.3067rem;

      .title {
        color: #828df4;
        font-size: 0.4533rem;
        font-weight: bold;
        background-image: url("~@@/images/pc/title_border.png");
        background-repeat: no-repeat;
        background-position: center bottom;
        background-size: 2.6rem 0.1467rem;
        text-align: center;
        flex: 1;
      }
      .more {
        display: none;
      }
    }
    .recruitment_info {
      color: #52575a;
      padding-bottom: 0;
      .left_wrapper {
        width: 5.3333rem;
        padding-top: 0.2667rem;
        border-right: 0.0133rem solid #ccc;
        margin-left: 0.4rem;
        ul {
          width: 5.6rem;
          li {
            margin-bottom: 0.6rem;
            .catalog {
              font-size: 0.3333rem;
              font-weight: bold;
            }
            .position {
              font-size: 0.2933rem;
            }
            .posnum {
              color: #7180ff;
              font-size: 0.2933rem;
            }
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
      .right_wrapper {
        padding: 0 0.2667rem;
        ul {
          li {
            margin-bottom: 0.28rem;
            width: 9.4533rem;
            height: 2.1467rem;
            background: #ffffff;
            border-radius: 0.08rem;
            padding: 0.2133rem;
            display: flex;
            align-items: center;

            .arrow {
              width: 0.12rem;
              height: 0.2933rem;
            }
            .content_wrapper {
              flex: 1;
              margin-right: 0.4rem;
              width: 8rem;
            }
            .title {
              font-size: 0.3333rem;
              font-weight: bold;
            }
            .base {
              font-size: 0.2933rem;
            }
            .desc {
              font-size: 0.2933rem;
              /deep/span,
              /deep/p {
                font-size: 0.2933rem !important;
              }
            }
            &:last-child {
              // margin-bottom: 0;
            }
          }
        }
        .more {
          width: 9.4533rem;
          height: 0.8933rem;
          background: #fff;
          font-size: 0.2667rem;
          margin: 0.24rem auto 0.04rem;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #919191;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/index/index.vue